import { render, staticRenderFns } from "./FaceDemoLayout.vue?vue&type=template&id=710fdc43"
import script from "./FaceDemoLayout.vue?vue&type=script&lang=js"
export * from "./FaceDemoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports